(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('SectorType', SectorType);

    SectorType.$inject = ['$resource'];

    function SectorType ($resource) {
        var resourceUrl =  'api/sector-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
